import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql, StaticQuery } from "gatsby";

import SEO from "components/SEO";
import Footer from "components/Footer";
import Nav from "components/Nav";
import Header from "components/Header";
import getTitleData from "utils/frontSiteConfig";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideNavBar: undefined,
      navHeight: 0,
      lastScrollPos: 0,
      locationData: getTitleData(this.props.location)
    };
  }
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  onResizeNav = height => {
    this.setState({ navHeight: height });
  };

  handleScroll = event => {
    if (this.state.lastScrollPos > event.currentTarget.scrollY) {
      //user is scrolling up
      this.setState({
        hideNavBar: false,
        lastScrollPos: event.currentTarget.scrollY
      });
    } else if (this.state.lastScrollPos + 150 < event.currentTarget.scrollY) {
      //user is scrolling down
      this.setState({
        hideNavBar: true,
        lastScrollPos: event.currentTarget.scrollY
      });
    }
  };

  render() {
    const {
      children,
      headerData,
      backgroundImg,
      location,
      logoImg,
      internalLinks
    } = this.props;
    return (
      <div className="min-h-screen flex flex-col font-sans">
        <SEO locationData={this.state.locationData} logoImg={logoImg} />
        <Nav
          headerData={headerData}
          headerNames={internalLinks}
          location={location}
          logo={logoImg}
          hidden={this.state.hideNavBar}
          onResizeNav={this.onResizeNav}
        />
        {location.pathname !== "/" ? (
          <div style={{ height: (this.state.navHeight * 2) / 3 }} />
        ) : null}
        <Header
          headerData={headerData}
          backgroundImg={backgroundImg}
          location={location}
          locationData={this.state.locationData}
          navHeight={this.state.navHeight}
        />
        <main
          onScroll={this.handleScroll}
          className="container mx-auto px-6 text-justify flex-grow mt-4 w-full"
        >
          {children}
        </main>
        <Footer location={location} />
      </div>
    );
  }
}

export default props => (
  <StaticQuery
    query={graphql`
      query {
        allContentfulHeader {
          edges {
            node {
              websiteTitle
              companyType
              slogan
              logo {
                fixed(quality: 100, width: 128) {
                  ...GatsbyContentfulFixed_withWebp
                }
              }
              homeImage {
                fluid(quality: 100, maxWidth: 1080) {
                  ...GatsbyContentfulFluid_withWebp
                }
              }
              engagementImage {
                fluid(quality: 100, maxWidth: 1080) {
                  ...GatsbyContentfulFluid_withWebp
                }
              }
              projectImage {
                fluid(quality: 100, maxWidth: 1080) {
                  ...GatsbyContentfulFluid_withWebp
                }
              }
              newsImage {
                fluid(quality: 100, maxWidth: 1080) {
                  ...GatsbyContentfulFluid_withWebp
                }
              }
              partnerImage {
                fluid(quality: 100, maxWidth: 1080) {
                  ...GatsbyContentfulFluid_withWebp
                }
              }
              contactImage {
                fluid(quality: 100, maxWidth: 1080) {
                  ...GatsbyContentfulFluid_withWebp
                }
              }
              notFoundImage {
                fluid(quality: 100, maxWidth: 1080) {
                  ...GatsbyContentfulFluid_withWebp
                }
              }
            }
          }
        }
        internalLinks {
          links {
            title
            slug
          }
        }
      }
    `}
    render={data => (
      <Layout
        headerData={data.allContentfulHeader.edges[0].node}
        logoImg={data.allContentfulHeader.edges[0].node.logo.fixed}
        internalLinks={data.internalLinks.links}
        {...props}
      />
    )}
  />
);

Layout.propTypes = {
  children: PropTypes.node.isRequired
};
